import * as tslib_1 from "tslib";
import { OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Subject } from 'rxjs';
import { sentry } from 'sentry';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var SEARCH_QUERY = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query searchLocationEnvironments($where: LocationEnvironmentWhereInput, $limit: Int, $offset: Int) {\n    locationEnvironments(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query searchLocationEnvironments($where: LocationEnvironmentWhereInput, $limit: Int, $offset: Int) {\n    locationEnvironments(\n      where: $where\n      orderBy: name_asc\n      limit: $limit\n      offset: $offset\n    ){\n      items {\n        id\n        name\n      }\n    }\n  }\n"])));
var FcLocationEnvironmentInputComponent = /** @class */ (function () {
    function FcLocationEnvironmentInputComponent(fuseTranslationLoaderService, apollo) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.apollo = apollo;
        this.showSearchIcon = false;
        this.requiredMark = false;
        this.preloadOptions = false;
        this.searchOnFocus = false;
        this.enableInfiniteScroll = true;
        this.showChevronIcon = false;
        this.reload$ = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.search = this.search.bind(this);
        this.displayWith = this.displayWith.bind(this);
    }
    FcLocationEnvironmentInputComponent.prototype.ngOnChanges = function (changes) {
        var sectorIdOld = changes.sectorId && changes.sectorId.previousValue;
        var sectorIdNew = changes.sectorId && changes.sectorId.currentValue;
        if (sectorIdNew && sectorIdOld !== sectorIdNew) {
            this.reload$.next();
        }
    };
    FcLocationEnvironmentInputComponent.prototype.search = function (searchTerm, limit, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!this.sectorId) {
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.apollo
                        .query({
                        query: SEARCH_QUERY,
                        variables: {
                            where: {
                                nameContains: searchTerm,
                                locationSectorId: this.sectorId,
                                archived: false
                            },
                            limit: limit,
                            offset: offset
                        },
                    })
                        .toPromise()
                        .then(function (result) {
                        return result.data['locationEnvironments']['items'];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    FcLocationEnvironmentInputComponent.prototype.displayWith = function (value) {
        return value && value.name;
    };
    return FcLocationEnvironmentInputComponent;
}());
export { FcLocationEnvironmentInputComponent };
var templateObject_1;
